<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <label> Compras/ Mapa de Cotação </label>
    </div>
    <v-container fluid
      ><v-row align="center">
        <v-col cols="12" sm="2">
          <v-btn
            color="info"
            to="/mapaCotacao/criar"
            v-if="isAllowed(10)"
            class="ma-2 white--text"
          >
            NOVO
          </v-btn>
        </v-col>
        <v-col cols="12" sm="8">
          <v-radio-group v-model="selectedFilter" row>
            <v-radio value="0">
              <template v-slot:label>
                <v-avatar size="25" color="primary">
                  <span class="white--text text-h6">TD</span>
                </v-avatar>
                <div class="ma-1 text-h5">Todas</div>
              </template></v-radio
            ><v-radio value="PC">
              <template v-slot:label>
                <v-avatar size="25" color="yellow">
                  <span class="white--text text-h6">PC</span>
                </v-avatar>
                <div class="ma-1 text-h5">Processo de Cotação</div>
              </template>
            </v-radio>
            <v-radio value="AA">
              <template v-slot:label>
                <v-avatar color="red" size="25">
                  <span class="white--text text-h6">AA</span>
                </v-avatar>
                <div class="ma-1 text-h5">Aguardando Aprovação</div>
              </template>
            </v-radio>
            <v-radio value="AG">
              <template v-slot:label>
                <v-avatar color="green" size="25">
                  <span class="white--text text-h6">AG</span>
                </v-avatar>
                <div class="ma-1 text-h5">Aprovado</div>
              </template>
            </v-radio>
            <v-radio value="D">
              <template v-slot:label>
                <v-avatar color="yellow" size="25">
                  <span class="white--text text-h6">D</span>
                </v-avatar>
                <div class="ma-1 text-h5">Declinada</div>
              </template>
            </v-radio>
            <v-radio value="PP">
              <template v-slot:label>
                <v-avatar color="yellow" size="25">
                  <span class="white--text text-h6">PP</span>
                </v-avatar>
                <div class="ma-1 text-h5">Pedido Parcial</div>
              </template>
            </v-radio>
            <v-radio value="PG">
              <template v-slot:label>
                <v-avatar color="green" size="25">
                  <span class="white--text text-h6">PG</span>
                </v-avatar>
                <div class="ma-1 text-h5">Pedido Gerado</div>
              </template>
            </v-radio>
            <v-radio value="I">
              <template v-slot:label>
                <v-avatar color="grey darken-1" size="25">
                  <span class="white--text text-h6">I</span>
                </v-avatar>
                <div class="ma-1 text-h5">Inativo</div>
              </template>
            </v-radio>
          </v-radio-group>
        </v-col>
        <v-col cols="12" sm="1">
          <!--<v-btn
            @click="baixarlista()"
            v-if="mapasCotacao.length > 0"
            class="ma-2 blue--text"
            align="right"
          >
            <v-icon>mdi-file-excel</v-icon>
            Baixar planilha
          </v-btn>-->
        </v-col>
      </v-row>
      <v-row align="right">
        <v-col cols="12" sm="6" md="3" class="text-left">
          <v-menu
            v-model="menuData1"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="computedDataIni"
                label="Data inicio"
                prepend-icon="mdi-calendar"
                v-mask="['##/##/####']"
                maxlength="10"
                v-bind="attrs"
                v-on="on"
                @input="onInputDate1"
                @click:clear="dataIni = null"
                clearable
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dataIni"
              @input="menuData1 = false"
              @change="dateChangeDataIni"
              :max="new Date().toISOString().substr(0, 10)"
              locale="pt-br"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="6" md="3" class="text-left">
          <v-menu
            v-model="menuData2"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="computedDataFim"
                label="Data fim"
                prepend-icon="mdi-calendar"
                v-mask="['##/##/####']"
                maxlength="10"
                v-bind="attrs"
                v-on="on"
                @input="onInputDate2"
                @click:clear="dataFim = null"
                clearable
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dataFim"
              @input="menuData2 = false"
              @change="dateChangeDataFim"
              locale="pt-br"
              forma
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
    </v-container>
    <v-card>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquisar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="filteredList"
        class="elevation-1"
        :loading="loading"
        loading-text="Buscando dados..."
        :options.sync="options"
        :footer-props="{
          showFirstLastPage: true,
          itemsPerPageText: 'Items por página',
          itemsPerPageOptions: [5, 10, 15, -1],
        }"
      >
        <template v-slot:item.status="{ item }">
          <v-avatar v-if="item.status == 'AA'" color="red" size="24">
            <span class="white--text text-h5">AA</span>
          </v-avatar>
          <v-avatar v-else-if="item.status == 'PC'" color="yellow" size="24">
            <span class="white--text text-h5">PC</span>
          </v-avatar>
          <v-avatar v-else-if="item.status == 'AG'" color="green" size="24">
            <span class="white--text text-h5">AG</span>
          </v-avatar>
          <v-avatar v-else-if="item.status == 'PP'" color="yellow" size="24">
            <span class="white--text text-h5">PP</span>
          </v-avatar>
          <v-avatar v-else-if="item.status == 'PG'" color="green" size="24">
            <span class="white--text text-h5">PG</span>
          </v-avatar>
          <v-avatar
            v-else-if="item.status == 'D'"
            color="grey darken-1"
            size="24"
          >
            <span class="white--text text-h5">D</span>
          </v-avatar>
          <v-avatar v-else color="blue-grey lighten-4" size="24">
            <span class="white--text text-h5">I</span>
          </v-avatar>
        </template>
        <template v-slot:item.pedidos="{ item }">
          <div v-if="item.pedidos && item.pedidos !== ''">
            <span v-for="(pedido, index) in item.pedidos.split(',')" :key="index">
              <a href="#" @click.prevent="abrirPdfPedido(pedido)" class="text--primary font-weight-medium text-decoration-underline">
              {{ pedido }}
              </a>
              <span v-if="index < item.pedidos.split(',').length - 1">, </span>
            </span>
          </div>
          <span v-else>—</span>
        </template>
        <template v-slot:item.solicitacoes="{ item }">
          <div v-if="item.solicitacoes && item.solicitacoes !== ''">
            <span v-for="(solicitacao, index) in item.solicitacoes.split(',')" :key="index">
              <a href="#" @click.prevent="abrirPdfSolicitacao(solicitacao)" class="text--primary font-weight-medium text-decoration-underline">
              {{ solicitacao }}
              </a>
              <span v-if="index < item.solicitacoes.split(',').length - 1">, </span>
            </span>
          </div>
          <span v-else>—</span>
        </template>
        <template v-slot:item.resquisicoes="{ item }">
          <div v-if="item.resquisicoes && item.resquisicoes !== ''">
            <span v-for="(requisicao, index) in item.resquisicoes.split(',')" :key="index">
              <a href="#" @click.prevent="abrirPdfRequisicao(requisicao)" class="text--primary font-weight-medium text-decoration-underline">
              {{ requisicao }}
              </a>
              <span v-if="index < item.resquisicoes.split(',').length - 1">, </span>
            </span>
          </div>
          <span v-else>—</span>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                class="mr-2"
                @click="show(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-file-search
              </v-icon>
            </template>
            <span>Visualizar em PDF</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                class="mr-2"
                @click="editar(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span v-if="isAllowed(10) && statusPermite(item) && item.mesmoComprador">Editar</span>
            <span v-else>Visualizar</span>
          </v-tooltip>
          <v-tooltip v-if="isInactive(idModulo)" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="error"
                class="mr-2"
                @click="declinar(item)"
                v-bind="attrs"
                v-on="on"
                :disabled="!podeInativarRegistro(item)"
              >
                mdi-close-thick
              </v-icon>
            </template>
            <span>Inativar</span>
          </v-tooltip>
          <v-tooltip v-if="isAllowed(10) && isApproving(10)" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="success"
                class="mr-2"
                @click="autorizar(item)"
                v-bind="attrs"
                v-on="on"
                :disabled="!statusPermiteAprovar(item)"
              >
                mdi-check-bold
              </v-icon>
            </template>
            <span v-if="isAllowed(10)">{{ textoTooltipAprovar(item) }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.dataCriacao="{ item }">
          <span>{{
            new Date(item.dataCriacao)
              .toLocaleString()
              .replace(/(.*)\D\d+/, "$1")
          }}</span>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import {
  canApproveModule,
  canDeclineModule,
  getModuleRule,
  getUserPermission,
  getUserRoles,
  isLoggedUserAdmin,
  logApprovalDiagnostics,
  explainApprovalButtonState,
} from "@/services/loginService";
import { downloadLista, getPdf } from "../../../services/mapaCotacaoService";
import { getPdf as getPedidoPdf } from "../../../services/pedidoService";
import { getPdf as getSolicitacaoPdf } from "../../../services/solicitacaoService";
import { getPdf as getRequisicaoPdf } from "../../../services/requisicaoService";
import { abrirJanelaPdf } from "@/services/pdfHelper";
import moment from "moment";

export default {
  name: "listaMapaCotacao",
  data() {
    return {
      idModulo: 10,
      selectedFilter: "0",
      loading: false,
      search: "",
      showAtivo: false,
      apenasLeitura: false,
      active_tab: 2,
      dataIni: null,
      dataFim: null,
      menuData1: false,
      menuData2: false,
      arrayEvents: null,
      headers: [
        {
          text: "MC",
          align: "start",
          value: "id",
        },
        { text: "Data Hora", value: "dataCriacao" },
        { text: "Pedido Gerado", value: "pedidos" },
        { text: "Solicitacões", value: "solicitacoes" },
        { text: "Requisições", value: "resquisicoes" },
        { text: "Responsavel", value: "responsavel" },
        { text: "Status", value: "status" },
        { text: "Ações", value: "actions", sortable: false, width: "18%" },
      ],
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      },
      filters: {
        id: [],
        dataCriacao: [],
        pedidos: [],
        solicitacoes: [],
        resquisicoes: [],
        responsavel: [],
      },
    };
  },
  computed: {
    ...mapState("mapaCotacao", ["mapasCotacao"]),
    ...mapState("local", ["locais"]),
    filteredList() {
      const searchLower = this.normalizeSearch(this.search);

      return this.mapasCotacao
        .filter((m) => {
          // 1. Filtro por texto digitado
          const buscaTexto = this.mapaMatchesSearch(m, searchLower);

          // 2. Filtro por data (se datas forem preenchidas)
          const dataValida =
            !this.dataIni ||
            !this.dataFim ||
            (new Date(m.dataCriacao.split("T")[0]) >=
              new Date(this.dataIni.split("T")[0]) &&
              new Date(m.dataCriacao.split("T")[0]) <=
                new Date(this.dataFim.split("T")[0]));

          // 3. Filtros refinados (filters)
          const filtrosOk = Object.keys(this.filters).every((f) => {
            if (this.filters[f].length < 1) return true;

            if (f === "data") {
              const dataFormatada = new Date(m[f])
                .toLocaleString()
                .replace(/(.*)\D\d+/, "$1");
              return this.filters[f].includes(dataFormatada);
            }

            if (f === "centroCusto") {
              return m.itens.some((p) =>
                this.filters[f].includes(p.centroCusto)
              );
            }

            return this.filters[f].includes(m[f]);
          });

          // 4. Filtro por status (se não for "0")
          const statusOk =
            this.selectedFilter === "0" || m.status === this.selectedFilter;

          return buscaTexto && dataValida && filtrosOk && statusOk;
        })
        .sort((a, b) => b.id - a.id);
    },
    computedDataIni() {
      return this.dataIni ? moment(this.dataIni).format("DD/MM/YYYY") : null;
    },
    computedDataFim() {
      return this.dataFim ? moment(this.dataFim).format("DD/MM/YYYY") : null;
    },
  },
  methods: {
    ...mapActions("mapaCotacao", [
      "atualizarMapaCotacao",
      "atualizarMapasCotacao",
    ]),
    ...mapActions("local", ["atualizarLocais"]),
    ...mapActions("condicaoPagamento", ["atualizarCondicoes"]),
    ...mapActions("solicitacao", ["atualizarProdutosCotacao"]),
    ...mapActions("fornecedor", [
      "atualizarFornecedores",
      "atualizarFornecedor",
    ]),
    normalizeSearch(value) {
      return (value || "")
        .toString()
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
    },
    fieldMatchesSearch(value, searchLower) {
      return this.normalizeSearch(value).includes(searchLower);
    },
    mapaMatchesSearch(mapa, searchLower) {
      if (!searchLower) return true;

      const requisicoes = mapa.resquisicoes || mapa.requisicoes || "";
      const camposMapa = [
        mapa.id,
        mapa.pedidos,
        mapa.solicitacoes,
        requisicoes,
        mapa.responsavel,
        mapa.status,
      ];

      return (
        camposMapa.some((campo) => this.fieldMatchesSearch(campo, searchLower)) ||
        (mapa.itens || []).some((item) =>
          [
            item.produto,
            item.descricao,
            item.codigo,
            item.nomeFornecedor,
            item.razaoSocialFornecedor,
            item.razaoSocial,
            item.centroCusto,
          ].some((campo) => this.fieldMatchesSearch(campo, searchLower))
        )
      );
    },
    columnValueList(val) {
      if (val == "data") {
        return this.mapasCotacao.map((d) =>
          new Date(d[val]).toLocaleString().replace(/(.*)\D\d+/, "$1")
        );
      } else {
        return this.mapasCotacao.map((d) => d[val]);
      }
    },
    editar(mapa) {
      this.atualizarMapaCotacao(mapa);
      if (this.isAllowed(10) && this.statusPermite(mapa) && mapa.mesmoComprador) {
        this.$router.push({
          path: "/mapaCotacao/editar",
          query: { ...this.$route.query, page: String(this.options?.page || 1) },
        });
      } else {
        this.$router.push({
          path: "/mapaCotacao/ver",
          query: { ...this.$route.query, page: String(this.options?.page || 1) },
        });
      }
    },
    declinar(mapaCotacao) {
      this.atualizarMapaCotacao(mapaCotacao);
      if (this.isInactive(this.idModulo) && this.podeInativarRegistro(mapaCotacao)) {
        this.$router.push(`/mapaCotacao/inativar`);
      } else {
        this.$router.push(`/mapaCotacao/ver`);
      }
    },
    autorizar(mapaCotacao) {
      this.atualizarMapaCotacao(mapaCotacao);
      this.$router.push(`/mapaCotacao/aprovar`);
    },

    doAjax() {
      if (!this.locais || this.locais.length == 0) {
        this.atualizarLocais();
      }
      this.atualizarCondicoes();
      this.atualizarProdutosCotacao();
      this.atualizarFornecedores();
    },

    async obter() {
      if (this.$store.getters["mapaCotacao/ultimaAtualizacaoListaMapa"]) {
        this.loading = true;
        await this.atualizarMapasCotacao();
        this.loading = false;
      }
    },

    baixarlista() {
      downloadLista();
    },
    show(item) {
      getPdf(item.id, abrirJanelaPdf());
    },
    abrirPdfSolicitacao(item) {
      getSolicitacaoPdf(item, abrirJanelaPdf());
    },
    abrirPdfRequisicao(item) {
      getRequisicaoPdf(item, abrirJanelaPdf());
    },
    abrirPdfPedido(item) {
      getPedidoPdf(item, abrirJanelaPdf());
    },
    isAllowed(id) {
      return getUserPermission(id);
    },
    isApproving(id) {
      return canApproveModule(id) || canDeclineModule(id);
    },
    isInactive(id) {
      return this.possuiPermissaoInativar(id);
    },
    possuiPermissaoInativar(id) {
      const regra = getModuleRule(id);
      return regra != null && regra.escrita === true && regra.inativar === true;
    },
    statusPermite(mapa) {
      return (mapa.status === "PC" || mapa.status === "AA" || mapa.status === "PG" || mapa.status === "AG" || mapa.status === "D" || mapa.status === "PP" );
    },
    podeInativarRegistro(mapa) {
      return (
        this.statusPermite(mapa) &&
        this.possuiPermissaoInativar(this.idModulo) &&
        (mapa.mesmoComprador || isLoggedUserAdmin())
      );
    },
    statusPermiteAprovar(mapa) {
      const permite = mapa.status === "AA"|| mapa.status === "AG" || mapa.status === "D";
      logApprovalDiagnostics("MapaCotacao/Lista:Aprovar", explainApprovalButtonState({
        modulo: this.idModulo,
        registro: mapa,
        action: "aprovar",
        statusPermitidos: ["AA", "AG", "D"],
      }));
      return permite;
    },
    statusPermiteDesaprovar(mapa) {
      return mapa.status === "AG";
    },
    textoTooltipAprovar(mapa) {
      return this.statusPermiteDesaprovar(mapa) ? "Desaprovar" : "Aprovar";
    },

    onInputDate1(val) {
      if (val.length == 10) {
        const newDate = moment(val, "DD/MM/YYYY");
        if (newDate.isValid() && newDate <= new Date()) {
          this.dataIni = moment(val, "DD/MM/YYYY").format("YYYY-MM-DD");
        }
      }
    },
    dateChangeDataIni(date) {
      this.dataIni = date;
    },
    onInputDate2(val) {
      if (val.length == 10) {
        const newDate = moment(val, "DD/MM/YYYY");
        if (newDate.isValid()) {
          this.dataFim = moment(val, "DD/MM/YYYY").format("YYYY-MM-DD");
        }
      }
    },
    dateChangeDataFim(date) {
      this.dataFim = date;
    },
  },
  mounted() {
    this.readOnly = !getUserPermission(1);
  },
  watch: {
    "options.page"(p) {
      this.$router.replace({
        query: { ...this.$route.query, page: String(p) },
      });
    },

    "$route.query.page": {
      immediate: true,
      handler(val) {
        const qPage = parseInt(val, 10);
        const next = Number.isFinite(qPage) && qPage > 0 ? qPage : 1;
        if (next !== this.options.page) {
          this.options = { ...this.options, page: next }; 
        }
      },
    },
  },
  created: function () {
    const f = this.$route.query.selectedFilter;
    const allowed = ['0', 'PC', 'AA', 'AG', 'D', 'PP', 'PG', 'I'];
    this.selectedFilter = allowed.includes(f) ? f : '0';
    this.doAjax();
    this.obter();
    var roles = getUserRoles();
    if (roles) {
      this.regras = roles;
    }
    const qPage = parseInt(this.$route.query.page, 10);
    this.options.page = Number.isFinite(qPage) && qPage > 0 ? qPage : 1;
  },
};
</script>
